import { hasScopesPermission } from '@tribeplatform/gql-client'
import { Image, Member } from '@tribeplatform/gql-client/types'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { PageHeader } from '@tribeplatform/react-ui-kit/PageHeader'

import { ProfilePicture } from '../Settings/ProfilePicture'
import { MemberActionButtons } from './MemberActionButtons'
import { MemberBackgroundImage } from './MemberBackgroundImage'
import { RoleBadge } from './RoleBadge'

export const MemberHeader = ({
  member,
  attached = 'bottom',
}: {
  member: Member
  attached?: 'top' | 'bottom' | 'none'
}) => {
  const [canUpdateMember] = hasScopesPermission(member, ['updateMember'])

  if (!member) return null
  return (
    <>
      <Card className="overflow-hidden" attached={attached}>
        <PageHeader
          title={
            <div className="flex items-center">
              <div className="truncate">{member?.name}</div>
              <RoleBadge member={member} />
            </div>
          }
          avatar={
            <ProfilePicture
              editable={canUpdateMember}
              member={member}
              size="2xl"
              className="ring-4 bg-surface-50 ring-surface-50 ring-offset-0 ring-offset-surface-50 sm:h-32 sm:w-32"
            />
          }
          backgroundColor={(member?.banner as Image)?.dominantColorHex}
          backgroundImage={<MemberBackgroundImage member={member} />}
          action={<MemberActionButtons member={member} />}
        />
      </Card>
    </>
  )
}
